// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-placeholder-group[data-v-18d3ff4c]{display:flex;align-items:center;flex-direction:column;line-height:21px;padding:20px 0 24px;text-align:center}.panel-placeholder-group .title[data-v-18d3ff4c]{font-size:16px;font-weight:500;margin:4px 0}.panel-placeholder-group .subtitle[data-v-18d3ff4c]{font-size:12px}.panel-placeholder-group .action[data-v-18d3ff4c]{margin-top:15px}", ""]);
// Exports
module.exports = exports;
